import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { replaceArrayOfObjects, reduceArrayOfObjectsByKey } from 'helpers/utils';

import { WalletStore } from './wallet.types';

const useWalletStoreBase = create<WalletStore>()(
  devtools(
    set => ({
      // #region States
      state: {
        walletSpotPrice: {},
        crossMarginChannel: {},
        multiCollateral: {},
        portfolio_margin: {},
        available_margin_cross: 0,
      },

      // #endregion

      // #region Actions
      actions: {
        updateWalletSpotPrices: data => {
          set(
            state => ({
              state: {
                ...state.state,
                walletSpotPrice: {
                  ...state.state.walletSpotPrice,
                  [data.s]: Number(data.p),
                },
              },
            }),
            false,
            'updateWalletSpotPrices'
          );
        },

        updatePortfolioMargin: data => {
          set(
            state => ({
              state: {
                ...state.state,
                portfolio_margin: {
                  ...state.state.portfolio_margin,
                  [data.index_symbol as string]: data,
                },
              },
            }),
            false,
            'updatePortfolioMargin'
          );
        },

        updateCrossMargin: data => {
          set(
            state => ({
              state: {
                ...state.state,
                crossMarginChannel: {
                  ...state.state.crossMarginChannel,
                  ...data,
                },
              },
            }),
            false,
            'updateCrossMargin'
          );
        },

        updateMultiCollateral: data => {
          set(
            state => {
              const { wallets } = data;
              const updatedData =
                data.action === 'snapshot'
                  ? wallets
                  : replaceArrayOfObjects(
                      Array.isArray(state.state.multiCollateral?.wallets)
                        ? state.state.multiCollateral.wallets
                        : [],
                      wallets || [],
                      'asset_id'
                    );

              return {
                state: {
                  ...state.state,
                  multiCollateral: {
                    ...state.state.multiCollateral,
                    ...data,
                    wallets: updatedData,
                    updated_at: new Date(),
                  },
                  available_margin_cross: reduceArrayOfObjectsByKey(
                    updatedData,
                    'available_margin_contrib'
                  ),
                },
              };
            },
            false,
            'updateMultiCollateral'
          );
        },
      },

      // #endregion
    }),
    {
      name: 'WalletStore',
    }
  )
);

export { useWalletStoreBase };
